import { useEffect, useRef } from "react";

type Props = {
  count: number;
  active: number;
  setActive: (index: number) => void;
  disabled?: boolean;
};

const WHEEL_DEBOUNCE_MS = 800;

export function SectionScroller({ count, active, setActive, disabled }: Props) {
  const isScrolling = useRef(false);

  useEffect(() => {
    if (disabled) return;
    function go(direction: 1 | -1) {
      if (isScrolling.current) return;
      const next = active + direction;
      if (next < 0 || next >= count) return;
      isScrolling.current = true;
      setActive(next);
      window.setTimeout(() => {
        isScrolling.current = false;
      }, WHEEL_DEBOUNCE_MS);
    }

    function onWheel(event: WheelEvent) {
      if (Math.abs(event.deltaY) < 4) return;
      go(event.deltaY > 0 ? 1 : -1);
    }

    function onKey(event: KeyboardEvent) {
      switch (event.key) {
        case "ArrowDown":
        case "PageDown":
          event.preventDefault();
          go(1);
          break;
        case "ArrowUp":
        case "PageUp":
          event.preventDefault();
          go(-1);
          break;
        case "Home":
          event.preventDefault();
          setActive(0);
          break;
        case "End":
          event.preventDefault();
          setActive(count - 1);
          break;
      }
    }

    window.addEventListener("wheel", onWheel, { passive: true });
    window.addEventListener("keydown", onKey);
    return () => {
      window.removeEventListener("wheel", onWheel);
      window.removeEventListener("keydown", onKey);
    };
  }, [active, count, setActive, disabled]);

  return null;
}
